<template>
  <div>
    <div v-if="!isShow" :class="{ mask: !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <div class="tab-container">
      <!-- 横向可滚动的标签栏 -->
      <div @click="handleClickComponent">
        <div class="tab-scroll-wrapper" ref="headertab">
          <div class="tab-header">
            <div
              style="position: relative"
              :style="{
                fontSize: datas.textSize + 'px',
                backgroundColor:
                  datas.activeIndex === index
                    ? datas.activeBackgroundColor
                    : datas.offBackgroundColor,
              }"
              v-for="(item, index) in datas.tagList"
              :key="index"
              @click="handleTabClick(item, index)"
              ref="tabItem"
              :class="[
                'tab-item',
                {
                  active:
                    datas.activeIndex === index && datas.moduleStyleType == 1,
                  activeLine:
                    datas.activeIndex === index && datas.moduleStyleType == 3,
                },
              ]"
            >
              <div>
                <span
                  :style="{
                    color:
                      datas.activeIndex === index
                        ? 'var(--theme-primary)'
                        : datas.offActiveColor,
                  }"
                >
                  {{ item.name }}</span
                >
                <div
                  :class="[
                    datas.moduleStyleType == 5
                      ? 'tab-item-icon-line'
                      : 'tab-item-icon',
                  ]"
                  v-if="datas.activeIndex === index"
                >
                  <img
                    v-if="datas.moduleStyleType == 4"
                    src="@/assets/svg/1.svg"
                    alt="svg"
                  />
                  <img
                    v-if="datas.moduleStyleType == 5"
                    src="@/assets/svg/2.svg"
                    alt="svg"
                  />
                  <img
                    v-if="datas.moduleStyleType == 2"
                    src="@/assets/svg/3.svg"
                    alt="svg"
                    style="width: 8px; height: 8px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="tab-content">
        <section style="margin-top: 10px">
          <div v-for="(item, index) in datas.tagList" :key="index">
            <div
              v-if="datas.activeIndex == index && item.comType === 'none'"
              style="
                width: 100%;
                text-align: center;
                padding-bottom: 30px;
                border: 1px solid red;
              "
              @click="handleClickComponent"
            >
              <p style="margin: 50px 0">请点击按钮添加模块</p>
              <div
                class="flex"
                style="
                  text-align: center;
                  margin-top: 50px;
                  justify-content: center;
                "
              >
                <div v-for="item in actionButtons.moduleButtons" :key="item.id">
                  <CustomButton
                    v-if="item.type === 'addModule'"
                    style="margin-left: 20px"
                    :text="item.text"
                    type="primary"
                    size="small"
                    @click="handleClick(item)"
                  />
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="item.comList.length > 0 && datas.activeIndex == index">
                <component
                  :is="v.component"
                  v-for="(v, i) in item.comList"
                  :key="i"
                  :data-index="i"
                  :datas="v.setStyle"
                  :isShow="v.isShow"
                  :data-type="v.type"
                  @handleCallbackComponent="handleCallbackComponent"
                >
                </component>
              </div>
            </div>
          </div>
        </section>
        <!-- <slot :activeKey="activeKey"></slot> -->
      </div>
      <CustomDialog
        title="添加模块"
        :visible.sync="dialogVisible"
        :showFooter="false"
        width="50%"
      >
        <!-- 自定义弹窗内容 -->
        <template #content>
          <div class="custom-content">
            <AddModule :datas="datas" @handleClick="handleAddModuleClick" />
          </div>
        </template>
      </CustomDialog>
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
// 引入相关静态数据配置
import { actionButtons } from "@/utils/defaultData";
import componentProperties from "@/utils/componentProperties"; // 组件数据
export default {
  name: "transversustag",
  props: {
    datas: Object,
    isShow: Boolean,
  },
  data() {
    return {
      dialogVisible: false,
      pageComponents: Array.from(componentProperties.values()),
      currentComponent: {},
    };
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.log(
          "transversustag组件的datadatas 变化了···················",
          newVal,
          oldVal,
        );
      },
      deep: true,
    },
  },
  methods: {
    handleClickComponent() {
      console.log(
        "横向标签component点击了组件模块点击111111111111111:",
        this.datas,
        this.datas.parentComponent,
      );
      this.$emit(
        "handleCallbackComponent",
        this.$utils.handleComponentObj({
          id: this.datas.parentComponent,
          ref: `${this.datas.parentComponent}style`,
          text: this.datas.text,
        }),
        this.datas,
      );
      // 这里可以根据需要更新父组件状态
    },
    // 横向标签component内部子组件回调处理子组件回调
    handleCallbackComponent(button, row) {
      console.log(
        "横向标签component内部子组件回调处理子组件回调:",
        button,
        row,
      );
      this.$emit("handleCallbackComponent", button, row);
      // 这里可以根据需要更新父组件状态
    },
    // 按钮点击处理方法
    handleClick(button, row) {
      // 可以在这里添加按钮点击逻辑
      if (button.handler) {
        this[button.handler](button, row);
      }
    },
    handleClick(button, row) {
      console.log("点击了按钮", button);
      this.dialogVisible = true;
    },
    // 处理标签点击
    handleTabClick(item, index) {
      if (index == this.datas.activeIndex) return;
      this.datas.activeIndex = index;
      // 执行滚动逻辑
      this.scrollToActiveTab(index);
      console.log("切换标签", this.datas, item, index);
      this.$emit(
        "handleCallbackComponent",
        {
          customStyle: {},
          handler: "handleClickComponent",
          icon: "",
          id: "transversustag",
          outline: true,
          ref: "transversustagstyle",
          text: "横向标签",
          type: "",
        },
        this.datas,
      );
    },
    // 核心：滚动到激活的tab项
    scrollToActiveTab(index) {
      // ===== 横向自动滚动逻辑 =====
      this.$nextTick(() => {
        const tab = this.$refs.headertab;
        const li = this.$refs.tabItem[index];
        if (!li || !tab) return;

        const liLeft = li.offsetLeft;
        const liRight = liLeft + li.offsetWidth;
        const clientWidth = tab.clientWidth;
        const SAFE = 90;
        /* 1. 先算出「应该滚动到哪里」 */
        let target = tab.scrollLeft; // 默认保持原位
        if (liRight > tab.scrollLeft + clientWidth - SAFE) {
          target = liRight - clientWidth + SAFE;
        } else if (liLeft < tab.scrollLeft + SAFE) {
          target = Math.max(0, liLeft - SAFE);
        }
        /* 2. 和目标不一致才真正滚动 */
        if (Math.abs(target - tab.scrollLeft) > 1) {
          tab.scrollTo({ left: target, behavior: "smooth" });
        }
      });
    },
    // 处理添加模块点击事件
    handleAddModuleClick(event) {
      console.log("处理添加模块点击事件了", event, this.datas);
      const currentComponent = JSON.parse(
        JSON.stringify(
          this.pageComponents.find((item) => item.component == event.item.name),
        ),
      );
      this.$store.commit("modules/SET_CURRENT_COMPONENT", currentComponent);
      // 插入组件id标识
      currentComponent.id = `page_${this.datas.parentComponent}_${
        currentComponent.component
      }_${new Date().getTime()}`;
      const obj = {
        name: currentComponent.setStyle.text,
        comType: currentComponent.component,
        comList: [currentComponent],
      };
      // 判断最后一个标签的comType是否为none ，如果是none 说明是新添加的标签 做替换处理
      // const lastComType =
      //   this.datas.tagList[this.datas.tagList.length - 1].comType;
      // if (lastComType === "none") {
      //   this.datas.tagList.splice(this.datas.tagList.length - 1, 1);
      // }
      // this.datas.tagList[this.datas.activeIndex] = obj
      // 只针对名称和模块类型是原有datas对象  把comList克隆  否则列表会统一更改
      this.datas.tagList[this.datas.activeIndex].name =
        this.pageComponents.find(
          (item) => item.component == event.item.name,
        ).setStyle.text;
      this.datas.tagList[this.datas.activeIndex].comType =
        this.pageComponents.find(
          (item) => item.component == event.item.name,
        ).component;
      this.datas.tagList[this.datas.activeIndex].comList = [currentComponent];
      console.log("点击完成后需要push的", obj, this.datas);
      // const currentTagIndex = this.datas.tagList.findIndex(
      //   (item) => item.comType == currentComponent.component,
      // );
      // this.datas.activeIndex = currentTagIndex;
      this.dialogVisible = false;
      const buttonObj = {
        id: obj.comType,
        ref: `${obj.comType}style`,
        text: obj.name,
        handler: "handleAddModuleClick",
        icon: "",
        outline: true,
        type: "",
      };
      this.$emit("handleCallbackComponent", buttonObj);
    },
  },
};
</script>

<style scoped>
.line-hover {
  transition: outline 0.3s ease;
}
.line-hover:hover {
  outline: 1px solid #348cf8; /* outline 不影响布局 */
  outline-offset: 0; /* 控制 outline 与元素的间距 */
}
/* 容器样式 */
.tab-container {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  /* padding: 10px; */
}

/* 横向滚动容器 - 核心滚动样式 */
.tab-scroll-wrapper {
  width: 100%;
  overflow-x: auto; /* 横向滚动 */
  overflow-y: hidden;
  /* 隐藏滚动条（兼容主流浏览器） */
  -ms-overflow-style: none;
  scrollbar-width: none;
}
/* 隐藏 Chrome/Edge 滚动条 */
.tab-scroll-wrapper::-webkit-scrollbar {
  display: none;
}

/* 标签栏 */
.tab-header {
  display: flex;
  background-color: #f9fafb;
  white-space: nowrap; /* 标签不换行 */
  padding: 0 8px;
}
.tab-item-icon {
  position: absolute;
  z-index: 99;
  top: -5px;
  right: 0;
}
.tab-item-icon-line {
  display: flex;
  justify-content: center;
}

/* 标签项样式 */
.tab-item {
  border-radius: 50px;
  padding: 5px 10px;
  margin-right: 10px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  position: relative; /* 用于定位下划线 */
  transition: color 0.2s;
  white-space: nowrap;
}

/* 标签 hover 效果 */
.tab-item:hover {
  color: var(--theme-primary);
}

/* 激活标签样式 */
.tab-item.active {
  color: var(--theme-primary);
  font-weight: 500;
}

/* 激活标签的底部下划线 - 核心样式 */
.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 25px;
  height: 3px;
  background-color: var(--theme-primary);
  border-radius: 5px;
}
.tab-item.activeLine::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  background-color: var(--theme-primary);
  border-radius: 5px;
}

/* 内容区域 */
.tab-content {
  /* padding: 20px; */
}
</style>
